import {
  ActionType,
  IFullStressTypeInfoResponse,
  FullStressTypeInfoData,
} from "models/stressCheck/fullStressInformation";

export const fullStressCheckTypeInfoAction = (
  payload: FullStressTypeInfoData
) => {
  return {
    type: ActionType.FULL_STRESS_INFO,
    payload,
  };
};

export const handleErrorAction = (payload: string) => {
  return {
    type: ActionType.FULL_STRESS_INFO_ERROR,
    payload,
  };
};

export const handleSuccesAction = (payload: IFullStressTypeInfoResponse) => {
  return {
    type: ActionType.FULL_STRESS_INFO_SUCCESS,
    payload,
  };
};

export const handleResetDataAction = () => {
  return {
    type: ActionType.FULL_STRESS_INFO_RESET_DATA,
  };
};
